import React from 'react';
import { AvisVerifiesContainer } from './MultiPage.styled';

const AvisNumberPartial = () => {

    return (
        <AvisVerifiesContainer>
            <span>★★★★★</span>
            <span>9,7/10 | 2 220 avis</span>
            <span>sur Avis Vérifiés</span>
        </AvisVerifiesContainer>
    );
}

export default AvisNumberPartial;